var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.direccionSeleccionada)?_c('b-container',[_c('v-card',[_c('address-form',{attrs:{"modo":'actualizar',"direccion":_vm.direccionSeleccionada},on:{"processAddress":_vm.updateAddress}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }